@use "~theme/typography";

.container {
  padding-top: 52px;
  grid-column: 1 / 10;
}

.icon {
  display: block;
  margin: auto;
}

.header {
  @include typography.body-semibold;
  text-align: center;
  margin: 12px 0 20px;
}

.buttonContainer {
  display: flex;
  justify-content: center;
  margin-bottom: 72px;
}

.button {
  max-width: 335px;
}
